import axios from "axios";

export async function loadStoredDocuments(transactionId: string) {
    const url = `${process.env.REACT_APP_LOAD_DOCUMENTS_BASE_URL}/${transactionId}/files`;
    return axios.get(url);
}

export async function removeStoredDocument(transactionId: string, fileId: string) {
    const url = `${process.env.REACT_APP_LOAD_DOCUMENTS_BASE_URL}/${transactionId}/files/${fileId}`;
    return axios.delete(url);
}